import { Typography } from 'antd';

const VersionMessage = () => <Typography.Text style={{color: "rgba(255,255,255,0.4)"}}>1.1.0.{(process.env?.REACT_APP_COMMIT_HASH || '').slice(0, 7)}</Typography.Text>;

export default VersionMessage;
